import {
  GetCoreDictionariesBanksQuery,
  GetCoreDictionariesCountriesQuery,
  useGetCoreDictionariesBanksQuery as useGeneratedBanksQuery,
  useGetCoreDictionariesCountriesQuery as useGeneratedCountriesQuery,
} from './generated';
import { unwrapQuery } from './unwrap';

export const useGetCoreDictionariesCountriesQuery = (
  ...args: Parameters<typeof useGeneratedCountriesQuery>
) =>
  unwrapQuery(
    useGeneratedCountriesQuery(...args),
    (raw: GetCoreDictionariesCountriesQuery | undefined) => raw?.coreDictionaries?.get,
  );

export const useGetCoreDictionariesBanksQuery = (
  ...args: Parameters<typeof useGeneratedBanksQuery>
) =>
  unwrapQuery(
    useGeneratedBanksQuery(...args),
    (raw: GetCoreDictionariesBanksQuery | undefined) =>
      raw?.coreOrganizations?.queryBanks?.organizations,
  );
